<template>
  <div>
    <v-list two-line v-if="tempAttachments.length > 0">
      <v-list-tile v-for="tempAttachment in tempAttachments" :key="tempAttachment._id">
        <v-list-tile-avatar tile size="30">
          <img  :src="tempAttachment.iconURL">
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title v-html="tempAttachment.title"></v-list-tile-title>
          <v-list-tile-sub-title>
            File Size : {{ tempAttachment.size }} bytes
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "AttachmentList",
  methods: {
    checkProgress(attachment) {
      return attachment.progress === null ? false : true;
    }
  },
  props: {
    tempAttachments: {
      type: Array
    }
  }
};
</script>
